export default __webpack_public_path__ + "static/media/Chandraprakash.a0c1652a.jpeg";